import { NGXLogger } from 'ngx-logger';
import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';

export interface SessionExpiredDialogRequest {
  message: string;
  onAccept: () => void;
  onReject: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class SessionExpiredDialogService {
  private readonly logger = inject(NGXLogger);

  private readonly dialogRequestSource = new Subject<SessionExpiredDialogRequest>();
  readonly dialogRequest$ = this.dialogRequestSource.asObservable();

  open(request: SessionExpiredDialogRequest): void {
    this.logger.debug('[SessionExpiredDialogService] Opening session expired dialog', {
      message: request.message
    });
    this.dialogRequestSource.next(request);
  }
}
